<template>
  <div class="alarmContainer">
    <div class="alarmContent">
      <div class="alarmIcon">
        <div class="text">{{ $t('lang.affiliate.activityNotStartYetMessageTitle') }}</div>
      </div>
      <div class="body">
        <div class="text1" v-html="hintText"/>
        <div class="buttons">
          <div class="yes-btn" @click="yesClick">{{ this.$t('lang.inviteFriends.ok') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirm3',
  props: ['confirmToDo', 'hintText'],
  data () {
    return {
    }
  },
  methods: {
    yesClick () {
      if (this.confirmToDo) {
        this.confirmToDo()
      }
      this.$store.state.confirmWinShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.alarmContainer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .8);
  z-index: 10;

  .alarmIcon {
    position: absolute;
    top: 5vw;
    left: 50%;
    transform: translate(-50%);
    width: 44.608vw;

    .text {
      text-align: center;
      color: #F7F7F7;
      font-family: Arial;
      font-weight: 700;
      font-size: 5.555vw;
      text-transform: capitalize;
    }

    img {
      margin-left: 8.5vw;
      width: 34.608vw;
      height: 31.927vw;
    }
  }

  .alarmContent {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 86.666vw;
    min-height: 60vw;
    transform: translate(-50%, -50%);
    background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%);
    border-radius: 4.166vw;
    border: 1px solid #737373;

    .body {
      position: relative;
      top: 15vw;
      left: 50%;
      transform: translate(-50%);
      width: 98%;

      .text1 {
        position: relative;
        top: 3vw;
        font-size: 4.444vw;
        line-height: 6.666vw;
        color: #FFFFFF;
        padding: 0 4.166vw;
        margin-bottom: 5vw;
      }

      .buttons {
        display: flex;
        justify-content: center;
      }

      .yes-btn {
        margin-top: 3.8vw;
        text-align: center;
        color: #000D2E;
        font-family: Inter;
        font-size: 4.166vw;
        line-height: 9.444vw;
        height: 9.444vw;
        width: 73.2vw;
        background: linear-gradient(0deg, #F1DAB0, #F1DAB0),
        linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
        border-radius: 2vw;
        font-weight: 600;
        text-transform: capitalize;
      }

      .no-btn {
        background: #F6D9AA;
        border-radius: 6px;
        line-height: 20px;
        padding: 12px 0px;
        text-align: center;
        color: #000D2E;
        font-size: 20px;
        margin-top: 20px;
        width: 100px;
      }
    }

    .cancel-btn {
      position: absolute;
      top: 4.166vw;
      right: 4.722vw;
      width: max-content;

      img {
        width: 3.611vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmWin/confirmWin9w.vue